module.exports = __webpack_public_path__ + "img/csltdnbanner.58472faf.png";